import { defineGlobalStyles } from "@chakra-ui/react-v3";

import { osanoStyles } from "./osanoStyles";

export const globalCss = defineGlobalStyles({
  html: {
    colorPalette: "neutral",
  },

  body: {
    textStyle: "body.14",
    background: "bg.default",
    color: "fg.default",
    overflow: "auto",
    transition: "background 300ms ease-out, color 300ms ease-out",
  },

  pre: {
    all: "revert",
    fontFamily: "mono",
  },
  code: {
    fontFamily: "mono",
  },
  img: {
    maxWidth: "unset",
  },
  ".chakra-image": {
    maxWidth: "100%",
  },

  'svg[data-icon-name="status/ProgressAnimated"]': {
    animation: "spinning 1s linear infinite",
  },
  ...osanoStyles,
  ...(import.meta.env?.VITE_OSANO_DNT_OFF === "true" && {
    ".osano-cm-dnt": { display: "none" },
  }),
});
